import { Paths } from 'src/routes';
import { TranslationKey } from 'src/typings/translation';

export type NavItem = {
  name: TranslationKey;
  icon: string;
  route?: string;
  hidden?: boolean;
  disabled?: boolean;
  children?: NavItemChild[];
};

export type NavItemChild = {
  name: TranslationKey;
  route: string;
  disabled?: boolean;
};

export function isNavItem(item: NavItem | NavItemChild): item is NavItem {
  return 'icon' in item;
}

export const getNavItems = (): NavItem[] => [
  {
    name: 'dashboard',
    route: Paths.base,
    icon: 'la-tachometer-alt'
  },
  {
    name: 'network.transport',
    icon: 'la-network-wired',
    children: [
      {
        name: 'stop.plural',
        route: Paths.stops.manage
      },
      {
        name: 'network.definition',
        route: Paths.networks.datasets
      },
      {
        name: 'network.active',
        route: Paths.activenetwork.activeLines
      },
      {
        name: 'zone.plural',
        route: Paths.zones.manage
      }
    ]
  },
  {
    name: 'fareManagement.singular',
    icon: 'la-money-bill-wave',
    children: [
      {
        name: 'fareManagement.profiles',
        route: Paths.travellerProfiles.manage
      },
      {
        name: 'fareManagement.productsAndPricing',
        route: Paths.productsPricing.zonePricingDefinitions
      },
      {
        name: 'fareManagement.salesChannels',
        route: Paths.salesChannels.manage
      },
      {
        name: 'fareManagement.salesRules',
        route: Paths.salesRules.overbooking
      },
      {
        name: 'shift.plural',
        route: Paths.shifts.reports
      },
      {
        name: 'fareManagement.salesEquipment',
        route: Paths.salesEquipment.salesEquipmentDevices
      }
    ]
  },
  {
    name: 'ticket.plural',
    icon: 'la-ticket-alt',
    children: [
      {
        name: 'crud.view',
        route: Paths.tickets.base
      },
      {
        name: 'ticket.sell',
        route: Paths.tickets.sell
      },
      {
        name: 'ticket.departures',
        route: Paths.tickets.departures
      },
      {
        name: 'ticket.layout',
        route: Paths.tickets.departures
      }
    ]
  },
  {
    name: 'customer.plural',
    route: Paths.customers.manage,
    icon: 'la-male'
  },
  {
    name: 'vehicle.plural',
    icon: 'la-bus',
    children: [
      {
        name: 'vehicle.plural',
        route: Paths.vehicles.base
      },
      {
        name: 'vehicleType.plural',
        route: Paths.vehicleTypes.base
      },
      {
        name: 'vehiclePlanning.singular',
        route: Paths.vehiclePlanning.journeyPatterns
      }
    ]
  },
  {
    name: 'report.plural',
    icon: 'la-file-alt',
    children: [
      {
        name: 'report.financial',
        route: Paths.reports.financial
      },
      {
        name: 'report.passengers',
        route: Paths.reports.passengers
      }
    ]
  },
  {
    name: 'support',
    route: Paths.support.base,
    icon: 'la-question-circle'
  },
  {
    name: 'user.plural',
    icon: 'la-users',
    children: [
      {
        name: 'verb.manage',
        route: Paths.users.base
      },
      {
        name: 'user.access',
        route: Paths.users.access.rights
      }
    ]
  },
  {
    name: 'setting.plural',
    icon: 'la-cog',
    children: [
      {
        name: 'language.plural',
        route: Paths.settings.languages
      },
      {
        name: 'setting.visualSettings',
        route: Paths.settings.visual
      },
      {
        name: 'setting.otherSettings',
        route: Paths.settings.other
      }
    ]
  }
];
